import { Box } from '@mui/material';

import { Outlet } from 'react-router-dom';

import SidebarMenu from './sidebar.common';

const SIDEBAR_FIXED_WIDTH_PX = 314;

export default function Layout() {
  return (
    <Box className='m-0 flex min-h-screen flex-auto flex-shrink-0 overflow-hidden bg-[#FAF9FC] text-gray-800 antialiased'>
      <SidebarMenu />

      <Box
        className='h-full flex-shrink-0 flex-grow'
        sx={{
          width: `calc(100vw - ${SIDEBAR_FIXED_WIDTH_PX}px)`,
          marginLeft: `${SIDEBAR_FIXED_WIDTH_PX}px`,
          overflow: 'auto',
        }}
      >
        <Box className='h-full w-full'>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
